module.exports = __webpack_public_path__ + "img/purchase5.609b7b96.png";